import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger"]
  static values = {
    open: { type: Boolean, default: false }
  }

  connect() {
    if (!this.openValue || !this.hasTriggerTarget) return

    requestAnimationFrame(() => {
      this.triggerTarget.click()
    })
  }
}
